import React from 'react';
import TextTruncate from 'react-text-truncate'; // recommend
import './FundFactsheetHeader.scss';
import ultilitiesService from 'shared/util/ultilitiesService';
import { FormattedMessage } from 'react-intl';


const FundFactsheetHeader = ({
  title, description, logo, reportingDate,
}) => (
  <div className="nw-fundfactsheet-header">
    {logo
      ? <img src={logo} alt="Logo" />
      : <h2>{title}</h2>
      }
    {reportingDate && (
      <small>
        <em>
          <FormattedMessage id="products.reportDate" />
          {': '}
          {ultilitiesService.formatDate(reportingDate)}
        </em>
      </small>
    )}
    {description && (
    <TextTruncate
      line={5}
      element="section"
      truncateText="…"
      text={description}
    />
    )}
  </div>
);

export default FundFactsheetHeader;
